// /* eslint-disable @typescript-eslint/no-unused-vars */
// import React, { useEffect, useRef, useState } from "react";
// import {
//   IconAdjustmentsHorizontal,
//   IconCalendarWeek,
//   IconCheck,
//   IconChevronDown,
//   IconX,
// } from "@tabler/icons-react";
// import NormalSearch from "../../components/common/NormalSearch";
// import { useFetchActivityLogs } from "../../apis/activityLogApis";
// import Pagination from "../../components/common/Pagination";
// import TableSkeleton from "../../components/skeleton/TableSkeleton";
// import NoDataFound from "../../components/common/NoDataFound";
// import FilterSidebarLog from "./_components/FilterSidebarLog";

// const chips = ["Salla", "Zid", "DTDC", "SkyExchange"];

// const Chips = () => (
//   <div className="flex items-center flex-wrap gap-2">
//     <p className="text-[#212121] text-base font-medium">Appied Filter : </p>
//     {chips.map((chip, i) => (
//       <span
//         key={i}
//         className="flex items-center gap-2 px-3 py-1.5 bg-[#F7F6F2] rounded-full text-xs font-medium text-[#212121]"
//       >
//         {chip}
//         <span className="bg-[#212121]/5 hover:bg-[#212121]/5 rounded-full p-1 cursor-pointer">
//           <IconX size={14} />
//         </span>
//       </span>
//     ))}
//   </div>
// );

// type DropdownProps = {
//   selected: string;
//   setSelected: (value: string) => void;
//   options: string[];
// };

// const Dropdown = ({ selected, setSelected, options }: DropdownProps) => {
//   const [open, setOpen] = useState(false);
//   const ref = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (ref.current && !ref.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="relative" ref={ref}>
//       <button
//         onClick={() => setOpen(!open)}
//         className="flex items-center rounded-full border-[0.5px] border-[#D2D2D2] px-4 py-2.5 text-sm bg-[#F7F6F2] text-[#212121] space-x-2"
//       >
//         <span>{selected || "Select option"}</span>
//         <IconChevronDown size={18} />
//       </button>

//       {open && (
//         <div className="absolute mt-1 w-40 bg-white border rounded-md shadow-lg z-50">
//           {options.map((option) => (
//             <div
//               key={option}
//               onClick={() => {
//                 setSelected(option);
//                 setOpen(false);
//               }}
//               className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
//             >
//               {option}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// type CheckboxDropdownProps = {
//   label: string;
//   options: string[];
//   selected: string[];
//   setSelected: React.Dispatch<React.SetStateAction<string[]>>;
// };

// const CheckboxDropdown: React.FC<CheckboxDropdownProps> = ({
//   label,
//   options,
//   selected,
//   setSelected,
// }) => {
//   const [open, setOpen] = useState(false);

//   const handleCheck = (option: string) => {
//     if (selected.includes(option)) {
//       setSelected(selected.filter((item) => item !== option));
//     } else {
//       setSelected([...selected, option]);
//     }
//   };

//   const ref = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (ref.current && !ref.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="relative" ref={ref}>
//       {/* Dropdown button */}
//       <button
//         type="button"
//         onClick={() => setOpen(!open)}
//         className="flex items-center rounded-full border-[0.5px] border-[#D2D2D2] px-4 py-2.5 text-sm bg-[#F7F6F2] text-[#212121] space-x-2"
//       >
//         {label}
//         <IconChevronDown size={18} />
//       </button>

//       {/* Dropdown menu */}
//       {open && (
//         <div className="absolute w-fit whitespace-nowrap bg-white border rounded-md shadow-lg z-50">
//           {options.map((option, i) => (
//             <label
//               key={i}
//               className="px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer flex items-center"
//             >
//               <label className="relative flex items-center cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={selected.includes(option)}
//                   onChange={() => handleCheck(option)}
//                   className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all
//                              bg-white checked:bg-[#FBD037] checked:text-white"
//                 />
//                 <IconCheck
//                   size={13}
//                   strokeWidth={3.5}
//                   className="absolute  text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                 />
//               </label>
//               <span className="pl-2 -pt-1">{option}</span>
//             </label>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const DateRangeInput = () => {
//   const [open, setOpen] = useState(false);
//   const [startDate, setStartDate] = useState<string>("");
//   const [endDate, setEndDate] = useState<string>("");

//   const ref = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (ref.current && !ref.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const formattedValue =
//     startDate && endDate ? `${startDate} - ${endDate}` : "";

//   return (
//     <div className="relative w-64" ref={ref}>
//       {/* Single Input */}
//       <div
//         onClick={() => setOpen(!open)}
//         className="flex items-center rounded-full border-[0.5px] border-[#D2D2D2] px-4 py-2.5 text-sm bg-[#F7F6F2] text-[#212121] space-x-3 cursor-pointer w-fit"
//       >
//         <input
//           readOnly
//           value={formattedValue}
//           placeholder="Select date range"
//           className="bg-transparent w-48 text-sm placeholder:text-[#212121] focus:outline-none"
//         />
//         <IconCalendarWeek size={16} stroke={1.5} />
//       </div>

//       {/* Dropdown with 2 inputs */}
//       {open && (
//         <div className="absolute mt-1 bg-white border border-gray-200 shadow-lg rounded-md p-4 z-50 w-64">
//           <div className="flex flex-col gap-2">
//             <div>
//               <label className="text-xs text-gray-500">Start Date</label>
//               <input
//                 type="date"
//                 value={startDate}
//                 onChange={(e) => setStartDate(e.target.value)}
//                 className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm"
//               />
//             </div>
//             <div>
//               <label className="text-xs text-gray-500">End Date</label>
//               <input
//                 type="date"
//                 value={endDate}
//                 onChange={(e) => setEndDate(e.target.value)}
//                 className="w-full border border-gray-300 rounded-md px-2 py-1 text-sm"
//               />
//             </div>

//             <button
//               onClick={() => setOpen(false)}
//               className="mt-2 w-full bg-[#212121]  text-[#fff] rounded-md py-2 text-sm "
//             >
//               Apply
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const ActivityLogs: React.FC = () => {
//   const [activity, setActivity] = useState<string[]>([]);
//   const [selected, setSelected] = useState("Integration");
//   const [warehouses, setWarehouses] = useState<string[]>([]);
//   const [userType, setUserType] = useState<string[]>([]);
//   const [page, setPageNo] = useState<number>(1);
//   const [limit, setLimit] = useState(10);
//   const [filters, setFilters] = useState<string[]>([]);
//   const [showFilter, setShowFilter] = useState(false);
//   const toggleFilter = () => setShowFilter(!showFilter);
//   const { data: activityLogsData, isLoading } = useFetchActivityLogs({
//     page,
//     limit,
//     userType,
//   });

//   console.log(activityLogsData, "data");

//   const logsArray = activityLogsData?.logs || [];
//   const totalPages = activityLogsData?.totalPages || 1;

//   const [open, setOpen] = useState(false);
//   const ref = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (e: MouseEvent) => {
//       if (ref.current && !ref.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const [openRow, setOpenRow] = useState<string | null>(null);

//   const handleToggle = (id: string) => {
//     setOpenRow(openRow === id ? null : id);
//   };

//   const handlePaginationFetch = (page: number) => {
//     setPageNo(page);
//   };

//   const targetModules = ["Integration", "Sales Channel", "3PL Company"];
//   const showActionsColumn = logsArray.some((l: any) =>
//     targetModules.includes(l.module)
//   );
//   const colCount = showActionsColumn ? 8 : 8;

//   return (
//     <>
//       <div className="[@media(min-width:1920px)]:w-8/12 [@media(min-width:1536px)]:w-10/12  w-full mx-auto p-6 space-y-6">
//         <div className="flex items-center justify-between w-full">
//           <div className="flex  items-center space-x-2 ">
//             <CheckboxDropdown
//               label="Activity"
//               options={["Order", "Inventory", "Fleet", "Forward / Reverse"]}
//               selected={activity}
//               setSelected={setActivity}
//             />
//             <CheckboxDropdown
//               label="Type"
//               options={["Admin", "Staff", "Driver", "Client"]}
//               selected={userType}
//               setSelected={setUserType}
//             />

//             {/* Warehouse */}
//             <CheckboxDropdown
//               label="Warehouse"
//               options={["WH01-Riyad", "WH02-Jeddah", "WH03-Damman"]}
//               selected={warehouses}
//               setSelected={setWarehouses}
//             />
//             <Dropdown
//               selected={selected}
//               setSelected={setSelected}
//               options={["Integration", "Sales Channel", "3PL Company"]}
//             />
//             <CheckboxDropdown
//               label="Channels"
//               options={["Salla", "Zid", "Amazone", "Flipkart"]}
//               selected={warehouses}
//               setSelected={setWarehouses}
//             />
//             <CheckboxDropdown
//               label="Company"
//               options={["DTDC", "Arramex", "Smasa"]}
//               selected={warehouses}
//               setSelected={setWarehouses}
//             />
//             <DateRangeInput />
//           </div>
//           <div className="flex items-center gap-2 ">
//             <button className="px-4 py-2 bg-[#FFD74F] text-sm font-medium rounded-full">
//               Apply
//             </button>
//             <button className="px-4 py-2 bg-black text-white text-sm font-medium rounded-full">
//               Reset
//             </button>
//           </div>
//         </div>

//         <Chips />
//         <div className="w-full space-y-4 border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]">
//           <div className="flex flex-col lg:flex-row justify-between gap-4">
//             <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
//               Activity Logs
//             </h1>
//             <div className="flex items-center gap-2">
//               <NormalSearch />
//               <button
//                 onClick={toggleFilter}
//                 className="p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
//               >
//                 <IconAdjustmentsHorizontal size={20} stroke={1.5} />
//               </button>
//             </div>
//           </div>
//           <div className="overflow-hidden overflow-x-auto">
//             {isLoading ? (
//               <div className="">
//                 <TableSkeleton
//                   columns={[
//                     "#",
//                     "User Name",
//                     "User Type",
//                     "Warehouse",
//                     "Log ID",
//                     "Activity Type",
//                     "Date & Time",
//                     "Failed Reason",
//                     "Action",
//                   ]}
//                   rows={6}
//                 />
//               </div>
//             ) : logsArray.length === 0 ? (
//               <NoDataFound />
//             ) : (
//               <table className="w-full whitespace-nowrap">
//                 <thead>
//                   <tr className="border-b border-dashed">
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       #
//                     </th>
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       User Name
//                     </th>
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       User Type
//                     </th>
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       Warehouse
//                     </th>
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       Log Id
//                     </th>
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       Activity Type
//                     </th>
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       Date & Time
//                     </th>
//                     <th className="text-sm font-medium text-[#212121]/70 p-2 text-left">
//                       Failed Reason
//                     </th>
//                     {showActionsColumn && (
//                       <th className="text-sm font-medium text-[#212121]/70 p-2 text-center">
//                         Actions
//                       </th>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y">
//                   {!isLoading &&
//                     logsArray.map((log: any, index: number) => {
//                       const id =
//                         log.shortId || `LOG-${(page - 1) * limit + index + 1}`;
//                       const showPayloadButton = targetModules.includes(
//                         log.module
//                       );

//                       return (
//                         <React.Fragment key={id}>
//                           <tr className="hover:bg-[#FBD037]/20">
//                             <td className="p-2 py-3 text-sm">
//                               {(page - 1) * limit + index + 1}
//                             </td>
//                             <td className="p-2 py-3 text-sm">
//                               <div className="flex items-center space-x-2">
//                                 <span>{log.createdByName || ""}</span>
//                               </div>
//                             </td>
//                             <td className="p-2 py-3 text-sm">
//                               {log.userType || ""}
//                             </td>
//                             <td className="p-2 py-3 text-sm">
//                               {log.warehouseName || ""}
//                             </td>
//                             <td className="p-2 py-3 text-sm">{id}</td>
//                             <td className="p-2 py-3 text-sm">
//                               {log.module}
//                             </td>{" "}
//                             <td className="p-2 py-3 text-sm">
//                               {log.createdAt
//                                 ? new Date(log.createdAt).toLocaleString()
//                                 : ""}
//                             </td>
//                             <td className="p-2 py-3">
//                               <span className="text-red-600 font-medium">
//                                 {log.failedReason?.message || "Failed"}
//                               </span>
//                             </td>
//                             {/* render Actions cell only when the column is visible */}
//                             {showActionsColumn && (
//                               <td className="p-2 py-3 text-center">
//                                 {showPayloadButton ? (
//                                   <button
//                                     onClick={() => handleToggle(id)}
//                                     className="size-9 bg-[#F7F6F2] border-[0.5px] rounded-full flex justify-center items-center m-auto"
//                                   >
//                                     <IconChevronDown
//                                       size={20}
//                                       strokeWidth={1.5}
//                                       className={`transition-transform duration-200 ${
//                                         openRow === id ? "rotate-180" : ""
//                                       }`}
//                                     />
//                                   </button>
//                                 ) : (
//                                   // an invisible placeholder to keep layout consistent
//                                   <div className="size-9 m-auto w-9 h-9 rounded-full" />
//                                 )}
//                               </td>
//                             )}
//                           </tr>

//                           {openRow === id && (
//                             <tr>
//                               <td colSpan={colCount} className="bg-gray-50">
//                                 <div className="text-green-600 text-sm p-4 rounded-lg overflow-x-auto w-full">
//                                   <pre>{JSON.stringify(log, null, 2)}</pre>
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </React.Fragment>
//                       );
//                     })}
//                 </tbody>
//               </table>
//             )}
//           </div>
//           <div className="flex justify-center">
//             {activityLogsData?.totalPages > 1 && (
//               <Pagination
//                 totalPages={activityLogsData?.totalPages}
//                 currentPage={page}
//                 fetchData={handlePaginationFetch}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//       {showFilter && (
//         <div className="fixed inset-0 z-50 flex justify-end">
//           <div
//             className="absolute inset-0 bg-black/40"
//             onClick={toggleFilter}
//           ></div>
//           <div className="relative w-[400px] h-full bg-white rounded-l-3xl shadow-lg overflow-auto transition-transform duration-300 ease-in-out">
//             <FilterSidebarLog setFilters={setFilters} onClose={toggleFilter} />
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ActivityLogs;

/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import {
  IconAdjustmentsHorizontal,
  IconCalendarWeek,
  IconCheck,
  IconChevronDown,
  IconX,
} from "@tabler/icons-react";
import NormalSearch from "../../components/common/NormalSearch";
import { useFetchActivityLogs } from "../../apis/activityLogApis";
import Pagination from "../../components/common/Pagination";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import NoDataFound from "../../components/common/NoDataFound";
import FilterSidebarLog from "./_components/FilterSidebarLog";
import {
  useFetchActivityLogFilters,
} from "../../apis/activityLogApis";
import { useLanguage, T } from "../../context/LanguageContext";

const chips = ["Salla", "Zid", "DTDC", "SkyExchange"];

const Chips = () => {
  const { t } = useLanguage();
  return (
    <div className="flex items-center flex-wrap gap-2">
      <p className="text-[#212121] text-base font-medium">{t("Applied Filter :")}</p>
      {chips.map((chip, i) => (
        <span
          key={i}
          className="flex items-center gap-2 px-3 py-1.5 bg-[#F7F6F2] rounded-full text-xs font-medium text-[#212121]"
        >
          {chip}
          <span className="bg-[#212121]/5 hover:bg-[#212121]/10 rounded-full p-1 cursor-pointer transition-colors">
            <IconX size={14} />
          </span>
        </span>
      ))}
    </div>
  );
};

type DropdownProps = {
  selected: string;
  setSelected: (value: string) => void;
  options: string[];
};

const Dropdown = ({ selected, setSelected, options }: DropdownProps) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useLanguage();

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center rounded-full border-[0.5px] border-[#D2D2D2] px-4 py-2.5 text-sm bg-[#F7F6F2] text-[#212121] space-x-2"
      >
        <span>{selected ? t(selected) : t("Select option")}</span>
        <IconChevronDown size={18} />
      </button>

      {open && (
        <div className="absolute mt-1 w-48 bg-white border rounded-md shadow-lg z-50">
          {options.map((option) => (
            <div
              key={option}
              onClick={() => {
                setSelected(option);
                setOpen(false);
              }}
              className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              {t(option)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

type CheckboxDropdownProps = {
  label: string;
  options: string[];
  selected: string[];
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
};

const CheckboxDropdown: React.FC<CheckboxDropdownProps> = ({
  label,
  options,
  selected,
  setSelected,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();

  const handleCheck = (option: string) => {
    if (selected.includes(option)) {
      setSelected(selected.filter((item) => item !== option));
    } else {
      setSelected([...selected, option]);
    }
  };

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center rounded-full border-[0.5px] border-[#D2D2D2] px-4 py-2.5 text-sm bg-[#F7F6F2] text-[#212121] space-x-2 whitespace-nowrap"
      >
        <span>
          {selected.length > 0 ? `${t(label)} (${selected.length})` : t(label)}
        </span>
        <IconChevronDown size={18} />
      </button>

      {open && (
        <div className="absolute mt-1 w-fit min-w-48 bg-white border rounded-md shadow-lg z-50">
          {options.map((option) => (
            <label
              key={option}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
            >
              <div className="relative flex items-center">
                <input
                  type="checkbox"
                  checked={selected.includes(option)}
                  onChange={() => handleCheck(option)}
                  className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] checked:bg-[#FBD037] transition-all"
                />
                <IconCheck
                  size={13}
                  strokeWidth={3.5}
                  className="absolute text-white pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                />
              </div>
              <span className="ml-3">{t(option)}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const DateRangeInput = () => {
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const { t } = useLanguage();

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formattedValue =
    startDate && endDate ? `${startDate} - ${endDate}` : t("Select date range");

  return (
    <div className="relative" ref={ref}>
      <div
        onClick={() => setOpen(!open)}
        className="flex items-center rounded-full border-[0.5px] border-[#D2D2D2] px-4 py-2.5 text-sm bg-[#F7F6F2] text-[#212121] space-x-3 cursor-pointer whitespace-nowrap"
      >
        <span className="text-sm">{formattedValue}</span>
        <IconCalendarWeek size={18} stroke={1.5} />
      </div>

      {open && (
        <div className="absolute mt-2 bg-white border border-gray-200 shadow-lg rounded-md p-4 z-50 w-72">
          <div className="space-y-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">
                {t("Start Date")}
              </label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">
                {t("End Date")}
              </label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
              />
            </div>
            <button
              onClick={() => setOpen(false)}
              className="w-full mt-3 bg-[#212121] text-white rounded-md py-2 text-sm font-medium hover:bg-[#333]"
            >
              {t("Apply")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// New JsonViewer Component with Copy Button
const JsonViewer: React.FC<{ data: any }> = ({ data }) => {
  const [copied, setCopied] = useState(false);
  const { t } = useLanguage();

  const jsonString = JSON.stringify(data, null, 2);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jsonString);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      alert(t("Failed to copy JSON"));
    }
  };

  return (
    <div className="relative bg-[#1e1e1e] text-[#d4d4d4] rounded-lg font-mono text-sm overflow-hidden">
      <button
        onClick={handleCopy}
        className="absolute top-3 right-3 px-4 py-1.5 bg-[#3c3c3c] hover:bg-[#4c4c4c] text-xs rounded-md transition-all flex items-center gap-2 z-10"
      >
        {copied ? (
          <>
            <IconCheck size={14} />
            {t("Copied!")}
          </>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
              <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
            </svg>
            {t("Copy JSON")}
          </>
        )}
      </button>
      <pre className="p-6 pt-14 overflow-x-auto max-h-96">{jsonString}</pre>
    </div>
  );
};

const ActivityLogs: React.FC = () => {
  const { t, language } = useLanguage();

  // Failed reason values are dynamic API messages — translated via the <T> component (API fallback)

  const formatLogDate = (dateStr: string) => {
    if (!dateStr) return "";
    let formatted = new Date(dateStr).toLocaleString("en-US");
    if (language === "ar") {
      formatted = formatted.replace(/\bAM\b/gi, "ص").replace(/\bPM\b/gi, "م");
    }
    return formatted;
  };


  const [activity, setActivity] = useState<string[]>([]);
  const [selected, setSelected] = useState<string | null>(null); // selected module
  const [warehouses, setWarehouses] = useState<string[]>([]);
  const [userType, setUserType] = useState<string[]>([]);
  const [page, setPageNo] = useState<number>(1);
  const [limit] = useState(10);
  const [appliedFilters, setAppliedFilters] = useState<any>({});
  const [showFilter, setShowFilter] = useState(false);
  const toggleFilter = () => setShowFilter(!showFilter);

  // fetch dynamic filter options
  const { data: filterOptions } = useFetchActivityLogFilters();

  const { data: activityLogsData, isLoading } = useFetchActivityLogs({
    page,
    limit,
    userType: appliedFilters.userType,
    modules: appliedFilters.modules,
    warehouseIds: appliedFilters.warehouseIds,
    from: appliedFilters.from,
    to: appliedFilters.to,
  });

  const logsArray = activityLogsData?.logs || [];
  const totalPages = activityLogsData?.totalPages || 1;

  const [openRow, setOpenRow] = useState<string | null>(null);

  const handleToggle = (id: string) => {
    setOpenRow(openRow === id ? null : id);
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const targetModules = [
    "Integration",
    "Sales Channel",
    "3PL Company",
    "Clients",
    "Bulk Uploads"
  ];
  const showActionsColumn = logsArray.some((l: any) =>
    targetModules.includes(l.module)
  );
  const colCount = showActionsColumn ? 9 : 8; 

  return (
    <>
      <div className="[@media(min-width:1920px)]:w-8/12 [@media(min-width:1536px)]:w-10/12 w-full mx-auto p-6 space-y-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-3">
            <CheckboxDropdown
              label="Activity"
              options={
                filterOptions?.modules || ["Order", "Inventory", "Fleet"]
              }
              selected={activity}
              setSelected={setActivity}
            />
            <CheckboxDropdown
              label="Type"
              options={
                filterOptions?.userTypes || [
                  "Admin",
                  "Staff",
                  "Driver",
                  "Client",
                ]
              }
              selected={userType}
              setSelected={setUserType}
            />
            <CheckboxDropdown
              label="Warehouse"
              options={
                filterOptions?.warehouses?.map((w: any) => w.name) || [
                  "WH01-Riyad",
                  "WH02-Jeddah",
                ]
              }
              selected={warehouses}
              setSelected={setWarehouses}
            />
            <Dropdown
              selected={selected || (filterOptions?.modules?.[0] ?? "")}
              setSelected={(val: string) => setSelected(val)}
              options={
                filterOptions?.modules || ["Integration", "Sales Channel"]
              }
            />
            <CheckboxDropdown
              label="Channels"
              options={[]}
              selected={[]}
              setSelected={() => {}}
            />
            <CheckboxDropdown
              label="Company"
              options={[]}
              selected={[]}
              setSelected={() => {}}
            />
            <DateRangeInput />
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => {
                // Apply top toolbar selections to filters
                setAppliedFilters({
                  userType,
                  modules: selected ? [selected] : undefined,
                  warehouseIds: (filterOptions?.warehouses || [])
                    .filter((w: any) => warehouses.includes(w.name))
                    .map((w: any) => w.id),
                });
              }}
              className="px-5 py-2.5 bg-[#FFD74F] text-sm font-medium rounded-full hover:bg-[#f5c94a] transition"
            >
              {t("Apply")}
            </button>
            <button
              onClick={() => {
                // Reset all top filters and applied filters
                setActivity([]);
                setUserType([]);
                setWarehouses([]);
                setSelected(null);
                setAppliedFilters({});
                setPageNo(1);
              }}
              className="px-5 py-2.5 bg-black text-white text-sm font-medium rounded-full hover:bg-gray-800 transition"
            >
              {t("Reset")}
            </button>
          </div>
        </div>

        <Chips />

        <div className="w-full border border-[#d2d2d2] rounded-[20px] bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] overflow-hidden">
          <div className="p-6 space-y-6">
            <div className="flex flex-col lg:flex-row justify-between gap-4">
              <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
                {t("Activity Logs")}
              </h1>
              <div className="flex items-center gap-3">
                <NormalSearch />
                <button
                  onClick={toggleFilter}
                  className="p-3 rounded-full border border-[#D8D8D8] bg-white hover:bg-gray-50 transition"
                >
                  <IconAdjustmentsHorizontal size={20} stroke={1.5} />
                </button>
              </div>
            </div>

            <div className="overflow-x-auto">
              {isLoading ? (
                <TableSkeleton
                  columns={[
                    "#",
                    t("User Name"),
                    t("User Type"),
                    t("Warehouse"),
                    t("Log ID"),
                    t("Activity Type"),
                    t("Date & Time"),
                    t("Failed Reason"),
                    ...(showActionsColumn ? [t("Actions")] : []),
                  ]}
                  rows={6}
                />
              ) : logsArray.length === 0 ? (
                <NoDataFound />
              ) : (
                <table className="w-full min-w-max whitespace-nowrap">
                  <thead>
                    <tr className="border-b border-dashed text-left">
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        #
                      </th>
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        {t("User Name")}
                      </th>
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        {t("User Type")}
                      </th>
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        {t("Warehouse")}
                      </th>
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        {t("Log ID")}
                      </th>
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        {t("Activity Type")}
                      </th>
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        {t("Date & Time")}
                      </th>
                      <th className="text-sm font-medium text-[#212121]/70 py-3 px-2">
                        {t("Failed Reason")}
                      </th>
                      {showActionsColumn && (
                        <th className="text-sm font-medium text-[#212121]/70 py-3 px-2 text-center">
                          {t("Actions")}
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {logsArray.map((log: any, index: number) => {
                      const id =
                        log.shortId || `LOG-${(page - 1) * limit + index + 1}`;
                      const showPayloadButton = targetModules.includes(
                        log.module
                      );

                      return (
                        <React.Fragment key={id}>
                          <tr className="hover:bg-[#FBD037]/10 transition">
                            <td className="py-3 px-2 text-sm">
                              {(page - 1) * limit + index + 1}
                            </td>
                            <td className="py-3 px-2 text-sm">
                              {log.createdByName || ""}
                            </td>
                            <td className="py-3 px-2 text-sm">
                              {log.userType ? t(log.userType) : ""}
                            </td>
                            <td className="py-3 px-2 text-sm">
                              {log.warehouseName || ""}
                            </td>
                            <td className="py-3 px-2 text-sm font-medium">
                              {id}
                            </td>
                            <td className="py-3 px-2 text-sm">
                              {log.module ? t(log.module) : ""}
                            </td>
                            <td className="py-3 px-2 text-sm">
                              {log.createdAt ? formatLogDate(log.createdAt) : ""}
                            </td>
                            <td className="py-3 px-2 text-sm">
                              {log.failedReason?.message ? (
                                <span className="text-red-600 font-medium">
                                  <T>{log.failedReason.message}</T>
                                </span>
                              ) : (
                                <span className="text-green-600 font-medium">
                                  {t("success")}
                                </span>
                              )}
                            </td>
                            {showActionsColumn && (
                              <td className="py-3 px-2 text-center">
                                {showPayloadButton ? (
                                  <button
                                    onClick={() => handleToggle(id)}
                                    className="size-9 bg-[#F7F6F2] border-[0.5px] border-[#D2D2D2] rounded-full flex justify-center items-center m-auto hover:bg-[#FBD037]/20 transition"
                                  >
                                    <IconChevronDown
                                      size={20}
                                      strokeWidth={1.5}
                                      className={`transition-transform duration-200 ${
                                        openRow === id ? "rotate-180" : ""
                                      }`}
                                    />
                                  </button>
                                ) : (
                                  <div className="size-9" />
                                )}
                              </td>
                            )}
                          </tr>

                          {/* Expanded Row with JSON Viewer */}
                          {openRow === id && showPayloadButton && (
                            <tr>
                              <td colSpan={colCount} className="p-0 bg-gray-50">
                                <div className="p-6">
                                  <JsonViewer data={log} />
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>

            {totalPages > 1 && (
              <div className="flex justify-center pt-4">
                <Pagination
                  totalPages={totalPages}
                  currentPage={page}
                  fetchData={handlePaginationFetch}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Filter Sidebar */}
      {showFilter && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={toggleFilter}
          />
          <div className="relative w-full max-w-md h-full bg-white shadow-2xl overflow-y-auto">
            <FilterSidebarLog
              setFilters={(f: any) => {
                setAppliedFilters(f);
                toggleFilter();
              }}
              onClose={toggleFilter}
              // filterOptions={filterOptions}
              // currentFilters={appliedFilters}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ActivityLogs;
